import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAIKBcXNnUDHiR6UvK-DghMPPT9Ke74Y0E",
  authDomain: "meucrqce-69d8c.firebaseapp.com",
  projectId: "meucrqce-69d8c",
  storageBucket: "meucrqce-69d8c.firebasestorage.app",
  messagingSenderId: "84015662822",
  appId: "1:84015662822:web:2983e2941eb925d295dd27",
  measurementId: "G-N3MLQ8055N"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const database = getDatabase(app);